import { useRouter } from 'next/router';
import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import _ from 'lodash';

import { navigateToVehiclePage } from '../../utils/api';
import DynamicVariantFilters from '../vehicle-variant-dynamic-filters';
import { useGutterSpacing } from '../../hooks/use-gutter-spacing';
import LoadingIndicator from '../loading-indicator';
import SaferVariant from '@/components/safer-variant';
import VariantButton from '../vehicle-variant-button';
import VariantFilter from '../vehicle-variant-filter';

import getNextVehicle from './utils/get-next-vehicle';
import getVariantCount from './utils/get-variant-count';
import { vehicleFiltersReducer } from './reducers';
import {
  StyledCloseButton,
  StyledContainer,
  StyledLabel,
  StyledMakeModel,
  StyledModalContainer,
  StyledUpdateButton,
  StyledYearFilter,
  StyledVehicleHeading,
  StyledSaferVariantGrid,
} from './styles';
import { getVehicleVariants } from '../../utils/apollo-requests/vehicles/get-vehicles';
import constructSlug from '../../utils/construct-slug';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'title' implicitly has an 'any' type.
const VehicleDetailHeaderFilter = ({ title, pageVehicle, pageVehicles, saferVariant }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  const initialState = {
    vehicles: [],
    staticFilter: {
      label: null,
      options: [],
    },
    dynamicFilters: [],
  };

  const [state, dispatch] = React.useReducer(vehicleFiltersReducer, initialState);
  const { staticFilter, dynamicFilters } = state;

  const makeModelTitleRef = React.useRef();

  React.useEffect(() => {
    if (makeModelTitleRef.current) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'focus' does not exist on type 'never'.
      makeModelTitleRef.current.focus();
    }
  }, [makeModelTitleRef]);

  const handleOpenFilters = async () => {
    setIsModalOpen(true);
    if (_.isEmpty(initialState.vehicles)) {
      setIsLoading(true);
      const vehicles = await getVehicleVariants({
        make: constructSlug(pageVehicle.makeDescription),
        model: constructSlug(pageVehicle.modelDescription),
      });

      dispatch({ type: 'FILTERS_INIT', payload: { vehicles, pageVehicle } });
      setIsLoading(false);
    }
  };

  const router = useRouter();
  const handleUpdateVehicleRecord = () => {
    setIsModalOpen(false);
    const nextVehicle = getNextVehicle(state);
    const { make, model } = router.query;
    const { year, slug } = nextVehicle;
    navigateToVehiclePage(make, model, year, slug);
  };

  return (
    <>
      <Grid container spacing={useGutterSpacing()}>
        <Grid item xs={12} lg={8}>
          <StyledVehicleHeading>
            {pageVehicle && (
              <Box>
                <StyledLabel aria-hidden="true">Year</StyledLabel>
                {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type 'number'. */}
                <StyledMakeModel tabIndex="-1" ref={makeModelTitleRef}>
                  {pageVehicle.year}
                </StyledMakeModel>
              </Box>
            )}
            <Box>
              <StyledLabel aria-hidden="true">Make/model</StyledLabel>
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type 'number'. */}
              <StyledMakeModel tabIndex="-1" ref={makeModelTitleRef}>
                {title}
              </StyledMakeModel>
            </Box>
          </StyledVehicleHeading>
          <Box>
            {pageVehicle && (
              <VariantButton label={`Variants (${getVariantCount(pageVehicles)})`} onClick={handleOpenFilters}>
                {pageVehicle.year + ' '}
                {pageVehicle.vehicleDescription}
                {pageVehicle.isBaseOption === 'T' && ' (Base Model)'}
              </VariantButton>
            )}
          </Box>
        </Grid>
        <StyledSaferVariantGrid item xs={12} lg={4}>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'actions' is missing in type '{ saferVariant: any; }' but required in type 'Omit<SaferVariantProps, never>'. */}
          {saferVariant && <SaferVariant saferVariant={saferVariant} />}
        </StyledSaferVariantGrid>
      </Grid>
      <Modal
        aria-labelledby="make-and-model"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        closeAfterTransition
        slotProps={{
          backdrop: { timeout: 500 },
        }}
      >
        <Fade in={isModalOpen}>
          <StyledModalContainer>
            <StyledContainer maxWidth={false}>
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ edge: string; ariaLabel: string; iconName: string; onClick: () => void; }' is missing the following properties from type '{ ariaLabel: any; className: any; edge: any; iconName: any; onClick: any; name: any; }': className, name */}
              <StyledCloseButton
                edge="end"
                ariaLabel="close modal"
                iconName="close"
                onClick={() => setIsModalOpen(false)}
              />
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: any; id: string; hasExtraSpacing: true; }' is not assignable to type 'IntrinsicAttributes & { theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<...> & HTMLAttributes<...> & { ...; }'. */}
              <StyledMakeModel id="make-and-model" hasExtraSpacing>
                {title}
              </StyledMakeModel>
              {isLoading ? (
                <LoadingIndicator />
              ) : (
                <>
                  <StyledYearFilter>
                    <VariantFilter
                      key={staticFilter.label}
                      label={staticFilter.label}
                      options={staticFilter.options}
                      selectedOption={staticFilter.selectedOption}
                      onChange={(event) => dispatch({ type: 'FILTERS_UPDATE_STATIC', payload: { event } })}
                      isFullWidth
                    />
                  </StyledYearFilter>
                  <DynamicVariantFilters
                    filters={dynamicFilters}
                    allVehicles={state.vehicles}
                    onChange={(event, item, index) =>
                      dispatch({ type: 'FILTERS_UPDATE_DYNAMIC', payload: { event, item, index } })
                    }
                    isFullWidth
                  />

                  <StyledUpdateButton
                    onClick={handleUpdateVehicleRecord}
                    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is of type 'unknown'.
                    disabled={!_.last(dynamicFilters).selectedOption}
                  >
                    View Variant
                  </StyledUpdateButton>
                </>
              )}
            </StyledContainer>
          </StyledModalContainer>
        </Fade>
      </Modal>
    </>
  );
};

export default VehicleDetailHeaderFilter;
